export default {"src":"/login-app/[GIT_HASH]/_next/static/media/shield_check.bf476b94.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};